import saunaBnbCakeLp from "../abis/development/saunaBnb/cakeLp";
import steamBnbCakeLp from "../abis/development/steamBnb/cakeLp";
import ssctBnbCakeLp from "../abis/development/ssctBnb/cakeLp";
import busdBoilerCakeLp from "../abis/development/busdBoiler/cakeLp";
import usdtBoilerCakeLp from "../abis/development/usdtBoiler/cakeLp";
import usdcBoilerCakeLp from "../abis/development/usdcBoiler/cakeLp";

const host = "https://bscscan.com/address";

export default [
  {
    name: "SAUNA-BNB Cake LP",
    type: "bnb",
    contractAddress: "0x555808D7e7b82b9beeF6388b65E1d98cF6069F75",
    abi: saunaBnbCakeLp.abi,
    url: `${host}/0x555808D7e7b82b9beeF6388b65E1d98cF6069F75`,
    decimals: 18,
  },
  {
    name: "STEAM-BNB Cake LP",
    type: "bnb",
    contractAddress: "0x3bcb9d470c8c3bf6a1db0133e172c403d851423c",
    abi: steamBnbCakeLp.abi,
    url: `${host}/0x3bcb9d470c8c3bf6a1db0133e172c403d851423c`,
    decimals: 18,
  },
  {
    name: "SSCT-BNB Cake LP",
    type: "bnb",
    contractAddress: "0x75c2214a0B3067c36D8896f20DD8A350fe029Cb8",
    abi: ssctBnbCakeLp.abi,
    url: `${host}/0x75c2214a0B3067c36D8896f20DD8A350fe029Cb8`,
    decimals: 18,
  },
  {
    name: "BUSD-BOILER Cake LP",
    type: "busd",
    contractAddress: "0x6F3505364Da2f11Fc28f8e80494C34292F5bb90C",
    abi: busdBoilerCakeLp.abi,
    url: `${host}/0x6F3505364Da2f11Fc28f8e80494C34292F5bb90C`,
    decimals: 18,
  },
  {
    name: "USDT-BOILER Cake LP",
    type: "usdt",
    contractAddress: "0x32F39A2b73b4f330A8c4BA906C831c62E7B4ec02",
    abi: usdtBoilerCakeLp.abi,
    url: `${host}/0x32F39A2b73b4f330A8c4BA906C831c62E7B4ec02`,
    decimals: 18,
  },
  {
    name: "USDC-BOILER Cake LP",
    type: "usdc",
    contractAddress: "0xc808e057a3d00610a996042c3387d43a7c99Cb00",
    abi: usdcBoilerCakeLp.abi,
    url: `${host}/0xc808e057a3d00610a996042c3387d43a7c99Cb00`,
    decimals: 18,
  },
];
